import { useState } from 'react'

const KEY = 'sidebar-collapsed'

export function useSidebar() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    return localStorage.getItem(KEY) === 'true'
  })

  function toggle() {
    setCollapsed(c => {
      const next = !c
      localStorage.setItem(KEY, String(next))
      return next
    })
  }

  return { collapsed, toggle }
}
